import { render, staticRenderFns } from "./AppXapp.vue?vue&type=template&id=ce2ad912"
import script from "./AppXapp.vue?vue&type=script&lang=js"
export * from "./AppXapp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports